/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StripeAccountsAddResponse
 */
export interface StripeAccountsAddResponse {
    /**
     * See https://stripe.com/docs/api/accounts/retrieve
     * @type {object}
     * @memberof StripeAccountsAddResponse
     */
    account: object;
}

/**
 * Check if a given object implements the StripeAccountsAddResponse interface.
 */
export function instanceOfStripeAccountsAddResponse(value: object): value is StripeAccountsAddResponse {
    if (!('account' in value) || value['account'] === undefined) return false;
    return true;
}

export function StripeAccountsAddResponseFromJSON(json: any): StripeAccountsAddResponse {
    return StripeAccountsAddResponseFromJSONTyped(json, false);
}

export function StripeAccountsAddResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeAccountsAddResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'account': json['account'],
    };
}

export function StripeAccountsAddResponseToJSON(json: any): StripeAccountsAddResponse {
    return StripeAccountsAddResponseToJSONTyped(json, false);
}

export function StripeAccountsAddResponseToJSONTyped(value?: StripeAccountsAddResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account': value['account'],
    };
}

